<template>
  <div class="start-window">
    <div v-if="!error" class="b21">{{ $t("AUTH_OAUTH_SIGNING_IN") }}</div>
    <template v-else>
      <p class="login-alerts">{{ errorText }}</p>
      <router-link to="/auth/login">{{ $t("AUTH_COMMON_SIGNIN_TO") }}</router-link>
    </template>
  </div>
</template>

<script>
// Возврат после входа через Яндекс ID / VK ID: ru-auth редиректит сюда с
// #token=…&email=… или #error=КОД (во фрагменте — чтобы токен не попал в логи).
import { AUTH_OAUTH } from "@/store/actions/auth";

export default {
  name: "OauthCallback",
  data() {
    return { error: "" };
  },
  computed: {
    errorText() {
      const key = "AUTH_ERROR_" + this.error;
      return this.$te(key) ? this.$t(key) : this.$t("AUTH_ERROR_OAUTH_FAILED");
    },
  },
  async mounted() {
    const params = new URLSearchParams(window.location.hash.slice(1));
    // Токен из адресной строки убираем сразу.
    window.history.replaceState(null, "", window.location.pathname);

    const error = params.get("error");
    if (error === "OAUTH_NEED_CONSENT") {
      // Новый пользователь пришёл со страницы входа — нужна галочка согласия.
      this.$router.replace({ path: "/auth/signup", query: { consent: params.get("provider") || "1" } });
      return;
    }
    if (error || !params.get("token")) {
      this.error = error || "OAUTH_FAILED";
      return;
    }
    await this.$store.dispatch(AUTH_OAUTH, { token: params.get("token"), email: params.get("email") });
    this.$router.replace({ path: "/main" });
  },
};
</script>
